var map = {
	"./da/generics.json": [
		7908,
		908
	],
	"./da/impersonation.json": [
		1306,
		306
	],
	"./da/messages.json": [
		8662,
		662
	],
	"./da/signin-menu.json": [
		5120,
		120
	],
	"./da/student-card.json": [
		7610,
		610
	],
	"./da/student-overview.json": [
		6715,
		715
	],
	"./da/study_start.json": [
		7376,
		376
	],
	"./da/studyportal.json": [
		4797,
		797
	],
	"./da/syndication.json": [
		7217,
		217
	],
	"./da/timetable.json": [
		7197,
		197
	],
	"./da/transcript.json": [
		2252,
		252
	],
	"./da/welcome.json": [
		1918,
		918
	],
	"./en/generics.json": [
		4092,
		92
	],
	"./en/impersonation.json": [
		9906,
		906
	],
	"./en/messages.json": [
		6862,
		862
	],
	"./en/signin-menu.json": [
		8728,
		347
	],
	"./en/student-card.json": [
		6674,
		674
	],
	"./en/student-overview.json": [
		6099,
		99
	],
	"./en/study_start.json": [
		6728,
		728
	],
	"./en/studyportal.json": [
		9941,
		941
	],
	"./en/syndication.json": [
		4441,
		441
	],
	"./en/timetable.json": [
		4677,
		677
	],
	"./en/transcript.json": [
		6420,
		420
	],
	"./en/welcome.json": [
		7974,
		974
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1803;
module.exports = webpackAsyncContext;